"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _localityCommonRegion = _interopRequireDefault(require("./locality-common-region"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var LocalityCommonDistrict = {
  GREATER_QUEANBEYAN: {
    districtId: 2131,
    name: 'Greater Queanbeyan',
    region: _localityCommonRegion.default.QUEANBEYAN,
    slug: 'greater-queanbeyan-queanbeyan-region-nsw'
  },
  YASS_VALLEY: {
    districtId: 2431,
    name: 'Yass Valley',
    region: _localityCommonRegion.default.SOUTHERN_TABLELANDS,
    slug: 'yass-valley-southern-tablelands-nsw'
  }
};
var _default = exports.default = LocalityCommonDistrict;